import React, { useRef } from "react";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonToolbar,
} from "@ionic/react";
import CityUpdatesFeed, { CityUpdatesFeedHandle } from "../components/CityUpdatesFeed";
import "./CityUpdates.css";

const CityUpdates: React.FC = () => {
  const feedRef = useRef<CityUpdatesFeedHandle>(null);

  const handleRefresh = async (event: CustomEvent) => {
    await feedRef.current?.reload();
    event.detail.complete();
  };

  return (
    <IonPage className="city-updates-page">
      <IonHeader className="class-header">
        <IonToolbar className="city-updates-header" />
      </IonHeader>

      <IonContent fullscreen className="city-updates-content web-centered">
        <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
          <IonRefresherContent />
        </IonRefresher>

        <div className="city-updates-shell">
          <div className="city-updates-hero city-updates-hero-wide">
            <div className="city-updates-card city-updates-page-card">
              <CityUpdatesFeed ref={feedRef} />
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CityUpdates;
